<template>
  <div class="mid-autumn">
    <van-swipe class="systemMessages" :class="showSystemMessagesList? '':'noSystemMessages'" vertical autoplay='4000' duration='1000' :show-indicators="false" :touchable="false">
        <van-swipe-item class="systemMessagesItem" v-for="(item,index) in systemMessagesList" :key="index">{{ item }}</van-swipe-item>
    </van-swipe>
    <div class="giftCoupon center">
      <img class="activeRules" @click="showPop('rule')" src="../../assets/images/activity/mid-autumn/activeRules.png"/>
      <img class="recordPrize" @click="showPop('record')" src="../../assets/images/activity/mid-autumn/recordPrize.png"/>
    </div>
    <div class="text1">本活动仅针对易加积分商品</div>
    <div class="center beginGo">
      <img v-if="!isBeginActive" src="../../assets/images/activity/mid-autumn/nextRob.png" alt="">
      <img v-else src="../../assets/images/activity/mid-autumn/nowFinish.png" alt="">
    </div>
    <div class="center countDown">
        <div class="day countDownNumber">
            {{ day }}
        </div>
        <div class="hour countDownNumber">
            {{ hour }}
        </div>
        <div class="minute countDownNumber">
            {{ minute }}
        </div>
        <div class="second countDownNumber">
            {{ second }}
        </div>
    </div>
    <div class="center notBegin">
      <img v-if="!isBeginActive" src="../../assets/images/activity/mid-autumn/notBeginBtn.png" @click="beginPrize">
      <img v-else src="../../assets/images/activity/mid-autumn/immediatelyRob.png" @click="beginPrize">
      <!-- <img src="../../assets/images/activity/mid-autumn/immediatelyRob.png" @click="beginPrize"> -->
    </div>
    <div class="immediatelyOrder">
        <img class="immediatelyOrderBtn" @click="gotoUrl()" src="../../assets/images/activity/mid-autumn/immediatelyOrderBtn.png"/>
        <div class="center chance">
           <span class="chanceNumber">{{chanceNumber}}</span>
        </div>
        <div class="text2">本活动仅针对易加积分商品</div>
    </div>
    <div class="bottom-text">
      请关注易加网公众号9月26日推文
    </div>

    <div class="qr-code">
      <img src="../../assets/images/mid-autumn-qr-code.png" />
    </div>
        <!-- 弹窗 - 说明与列表 -->
    <van-popup v-model="popShow" class="turntable-pop" :close-on-click-overlay="false" closeable>
      <div class="pop-title">
        {{ popType === "rule" ? "活动规则" : "中奖记录" }}
      </div>

      <!-- 活动规则 -->
      <div v-if="popType === 'rule'">
        <div class="pop-content">
          <span class="pop-content-label">活动时间：</span>
          <span>活动时间：2021年9月21日——2021年 10 月1日;</span>
        </div>
        <div class="pop-content">
          <span class="pop-content-label">参与对象：</span>
          <span>易加修理厂用户;</span>
        </div>
        <div class="pop-content">
          <span class="pop-content-label">活动说明：</span>
          <div>1.活动期间每天14:00—15:00开启抢六折券通道，每日限量抢完即止，六折券有效期至2021年10月31日;</div>
          <div>2.活动期间每笔满20000积分的订单可获得一次积分返现机会，返现积分面值为188，888，1888，8888，免单;</div>
          <div>3.每个账户在活动期内有10次返现机会，订单发货后，返还积分自动到账，若取消订单，返现机会不予恢复;</div>
          <div>4.本活动最终解释权归博世易加网所有，如有疑问请咨询客服;</div>
        </div>
      </div>

      <!-- 中奖记录 -->
      <div v-else class="record-list">
        <div class="record-list-row list-title" v-if="recordList.length">
          <div class="record-list-orderNumber">中奖订单</div>
          <div class="record-list-orderStatus">订单状态</div>
          <div class="record-list-detail">奖品明细</div>
        </div>
        <div class="record-list-box" v-if="recordList.length">
          <div class="record-list-row" v-for="(item, index) in recordList" :key="index">
            <div class="record-list-orderNumber">
              {{ item.orderNumber || 3453455434453 }}
            </div>
            <div class="record-list-orderStatus">{{ item.orderStatus || '订单状态' }}</div>
            <div class="record-list-detail">{{ item.couponValue || 0 }}</div>
          </div>
        </div>
        <div v-else style="text-align: center; margin-top: 20px">
          暂无中奖记录
        </div>
      </div>
    </van-popup>

    <van-overlay class="hasPrize-box" :show="showPrizeBox">
      <div v-if="isPrize">
      <img class="hasPrize-bg" src="../../assets/images/activity/mid-autumn/2021-midAutumn-1.png">
      <img class="btn1"  @click="showPrizeBox = false"  src="../../assets/images/activity/mid-autumn/2021-midAutumn-btn1.png">
      <img class="btn2" @click="gotoUrl()"  src="../../assets/images/activity/mid-autumn/2021-midAutumn-btn2.png">
      </div>

      <div v-else>
        <img class="hasPrize-bg" src="../../assets/images/activity/mid-autumn/2021-midAutumn-2.png">
        <img class="btn3" @click="showPrizeBox = false" src="../../assets/images/activity/mid-autumn/2021-midAutumn-btn3.png">
      </div>

    </van-overlay>

    <!-- <van-overlay class="noPrize-box" :show="showNoPrize" @click="show = false">
      <img class="hasPrize-bg" src="../../assets/images/activity/mid-autumn/2021-midAutumn-1.png">
      <img class="btn3" src="../../assets/images/activity/mid-autumn/2021-midAutumn-btn3.png">
    </van-overlay> -->

  </div>
</template>

<script>
import { Dialog } from 'vant'
import activityApi from '../../api/activity'
import { userUtils } from '@/utils/auth'
import { commonUtils } from '@/utils/common'

export default {
  components: {
    [Dialog.Component.name]: Dialog.Component
  },
  data () {
    return {
      systemMessagesList: [],
      showbaner: [
        '恭喜****获得188积分',
        '恭喜*****获得888积分',
        '恭喜**获得188积分',
        '恭喜*****获得888积分',
        '恭喜*********获得188积分',
        '恭喜***获得188积分',
        '恭喜*****获得188积分',
        '恭喜********厂获得8888积分',
        '恭喜****获得188积分',
        '恭喜******获得188积分',
        '恭喜***获得888积分',
        '恭喜******获得188积分',
        '恭喜********获得188积分',
        '恭喜****获得888积分',
        '恭喜**厂获得188积分',
        '恭喜***获得888积分',
        '恭喜*****获得188积分',
        '恭喜********获得888积分',
        '恭喜****获得188积分',
        '恭喜******获得188积分',
        '恭喜***获得888积分',
        '恭喜******获得188积分',
        '恭喜***厂获得免单卷',
        '恭喜*****获得888积分',
        '恭喜**获得188积分',
        '恭喜***厂获得188积分',
        '恭喜*****获得188积分',
        '恭喜********获得888积分'
      ],
      startActiveTime: '',
      rollNumbers: 10,
      day: 0,
      hour: 0,
      minute: 0,
      second: 0,
      startTime: 0,
      chanceNumber: 10,
      isBeginActive: false,
      // isBeginActive: true,
      popShow: false,
      popType: '',
      recordList: [],
      title: '',
      showPrizeBox: false,
      isPrize: false,
      showSystemMessagesList: true,
      dateNow: 0,
      test: ''
    }
  },

  computed: {
  },

  created () {
    this.clientInfo = userUtils.getClientInfo()
    if (!this.clientInfo) {
      window.location.href = commonUtils.getExtraSite() + '/#/login'
    }
    setInterval(() => {
      this.dateNow = Date.now()
      // this.test = '2021-10-01 15:11:00'
      // this.dateNow = new Date('2021-10-01 15:11:00').getTime()
      this.showBanner()
      let nowDay = new Date().getDate()
      let nowHour = new Date().getHours()
      let nowMonth = new Date().getMonth() + 1
      if (this.dateNow < new Date('2021/9/21 14:00:00').getTime()) {
        this.startActiveTime = '2021/9/21 14:00:00'
      } else if (this.dateNow === new Date('2021/9/21 14:00:00').getTime()) {
        this.startActiveTime = '2021/' + nowMonth + '/' + nowDay + ' 15:00:00'
      } else if (this.dateNow > new Date('2021-9-21 14:00:00').getTime() && nowHour === 14) {
        // nowDay = nowDay + 1
        this.startActiveTime = '2021/' + nowMonth + '/' + nowDay + ' 15:00:00'
      } else if (this.dateNow > new Date('2021-9-21 14:00:00').getTime() && nowHour < 14) {
        this.startActiveTime = '2021/' + nowMonth + '/' + nowDay + ' 14:00:00'
      } else {
        nowDay = nowDay + 1
        this.startActiveTime = '2021/' + nowMonth + '/' + nowDay + ' 14:00:00'
      }
      this.showTime(this.startActiveTime)
    }, 1000)
    this.getMidAutumnRecordList() // 中奖记录
  },
  methods: {
    showBanner () {
      if (this.dateNow < new Date('2021/9/21 14:00:00')) {
        this.showSystemMessagesList = false
      } else {
        this.showSystemMessagesList = true
        this.systemMessagesList = this.showbaner
      }
    },
    showTime (startActiveTime) {
      this.day = '0'
      this.hour = '0'
      this.minute = '0'
      if (this.dateNow > new Date('2021/10/1 14:59:59').getTime()) {
        this.startTime = this.dateNow
        this.isBeginActive = false
        return
      } else {
        this.startTime = new Date(startActiveTime).getTime() // 活动开始时间
      }
      let nowTime = this.dateNow
      let nowHour = new Date().getHours()
      let allSecond = Math.floor((this.startTime - nowTime) / 1000)
      this.day = Math.floor(allSecond / 86400)
      this.hour = Math.floor(allSecond / 3600 % 24)
      this.minute = Math.floor(allSecond / 60 % 60)
      if (nowHour === 14 && this.day === 0) {
        // this.hour = 0
        this.isBeginActive = true
        this.title = '距离本场抢卷结束还有'
      } else {
        this.title = '距离下一场抢卷还有'
        this.isBeginActive = false
        // console.log(false, '距离下一场抢卷还有' + this.day + '天' + this.hour + '时' + this.minute)
      }
      // if (this.minute === 60) {
      //   this.hour = this.hour + 1
      //   this.minute = 0
      // }
      this.second = Math.floor(allSecond % 60)
    },
    // 展示弹窗
    showPop (type) {
      this.popType = type
      this.popShow = true
      // if (type === 'record') {
      //   this.getMidAutumnRecordList()
      // }
    },
    // 抽奖
    getMidAutumnInfo () {
      this.$toast.loading({
        message: '加载中...',
        forbidClick: true,
        loadingType: 'spinner',
        duration: 0
      })
      activityApi.getMidAutumnInfo().then(res => {
        this.$toast.clear()
        if (res.data.resultCode === '0') {
          if (res.data.resultData && res.data.resultData.obtainCoupon) {
            this.showPrizeBox = true
            if (res.data.resultData.obtainCoupon === '1') {
              this.isPrize = true
            }
          } else {
            Dialog.alert({
              title: '提示',
              message: '您今天已经抽过奖'
            }).then(() => {
            })
          }
        }
      }).catch(() => {
        this.$toast.clear()
      })
    },
    // 获取中秋中奖记录
    getMidAutumnRecordList () {
      this.$toast.loading({
        message: '加载中...',
        forbidClick: true,
        loadingType: 'spinner',
        duration: 0
      })
      activityApi.getMidAutumnRecordList().then(res => {
        this.$toast.clear()
        if (res.data.resultCode === '0') {
          this.recordList = res.data.resultData.midAutumnRecordList
          this.chanceNumber = 10 - this.recordList.length
        }
      }).catch(() => {
        this.$toast.clear()
      })
    },
    beginPrize () {
      if (this.dateNow > new Date('2021/10/1 14:59:59').getTime()) {
        this.$alert('活动已结束', '提示', {
          confirmButtonText: '确定'
        })
        return
      }
      if (this.isBeginActive) {
        this.getMidAutumnInfo()
      } else {
        Dialog.alert({
          title: '提示',
          message: '活动还未开始'
        }).then(() => {
        })
      }
    },
    gotoUrl () {
      window.location.href = commonUtils.getExtraSite() + '/#/goodsGifts'
    }
  }
}
</script>

<style lang="less" scoped>
.mid-autumn {
  height: 1580px;
  box-sizing: border-box;
  padding-top: 212px;
  background: url("../../assets/images/activity/mid-autumn/mid-autumnBg.png") no-repeat;
  background-size: 100%;
  color: #fff;
  img {
    width: 100%;
    height: auto;
  }
  .center {
    text-align: center;
  }
  .systemMessages {
    height: 25px;
    line-height: 25px;
    width: 240px;
    margin:0 auto;
    text-align: center;
    color: #FAD5B9;
    border: 1px solid #FAD5B9;
    border-radius:15px;
    .systemMessages-item{
        height: 25px;
        line-height: 25px;
    }
  }
  .noSystemMessages{
    opacity: 0;
  }
  .giftCoupon{
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 30px;
    .activeRules{
      width: 150px;
    }
    .recordPrize{
      width: 100px;
    }
    img{
      height: 30px;
      margin: 0 20px;
    }
  }
  .beginGo{
    // color: #FFF;
    margin-top: 220px;
    // font-size:16px;
    // text-shadow:#666 1px 1px;
    img{
      height: 24px;
      width: auto;
    }
  }
  .notBegin{
    img{
      height: 34px;
      width: auto;
    }

  }

  .usefulLife{
      color: #f0CBA8;
  }
  .immediatelyOrder{
    text-align: center;
    margin-top: 244px;
    .immediatelyOrderBtn{
      height: 28px;
      width: 100px;
      margin-top:40px;
    }
    .chance{
        box-sizing: border-box;
        .chanceNumber{
          display: inline-block;
          color: #FAD5B9;
          padding-top: 4px;
          font-size: 20px;
          vertical-align:middle
        }
    }
  }
  .countDown{
    // margin-top: 250px;
    display: flex;
    justify-content: center;
    align-items: center;
    .countDownNumber{
        width: 40px;
        height: 60px;
        font-size: 20px;
        color: #FAD5B9;
        padding-top:6px;
        text-align: center;
        box-sizing: border-box;
        margin: 20px 15px;
        border-radius:10px
    }
    .day{
      background: url("../../assets/images/activity/mid-autumn/day.png") no-repeat;
      background-size: 108%;
    }
    .hour{
      background: url("../../assets/images/activity/mid-autumn/hour.png") no-repeat;
      background-size: 108%;
    }
    .minute{
      background: url("../../assets/images/activity/mid-autumn/minute.png") no-repeat;
      background-size: 108%;
    }
    .second{
      background: url("../../assets/images/activity/mid-autumn/second.png") no-repeat;
      background-size: 108%;
    }
  }
  .turntable-pop {
    width: 300px;
    height: 400px;
    border-radius: 10px;
    box-sizing: border-box;
    padding: 20px 18px;
    color: #000;
    overflow: hidden;

    .pop-title {
      font-size: 18px;
      font-weight: bold;
      text-align: center;
    }

    .pop-content {
      margin-top: 18px;
      line-height: 20px;

      .pop-content-label {
        font-weight: bold;
      }
    }

    .record-list-row {
      display: flex;
      align-items: center;
      margin-top: 10px;
      justify-content: center;

      .record-list-orderNumber {
        width: 40%;
        text-align: center;
      }
      .record-list-orderStatus {
        width: 30%;
        text-align: center;
      }

      .record-list-detail {
        width: 30%;
        text-align: center;
      }
    }
    .record-list-box {
      height: 250px;
      overflow-y: auto;
      font-size: 12px;

      .more-data {
        text-align: center;
        margin-top: 15px;
      }
    }
    .list-title {
      font-size: 14px;
      font-weight: bold;
      margin-top: 15px;
    }
  }
}
.hasPrize-bg{
  position: relative;
  left: calc(50vw - 150px);
  top: 200px;
  width: 300px !important;
  height: 200px !important;
}
.hasPrize-box{
  img{
    width: 100px;
  }
}
.btn1{
  position: relative;
  top: 150px;
  left: 60px;
  z-index: 10;
}
.btn2{
  position: relative;
  top: 150px;
  left: 120px;
  z-index: 10;
}
.noPrize-box{
  position: relative;
  left: calc(50vw - 150px);
  top: 200px;
  width: 300px !important;
  height: 200px !important;
}
.btn3{
  width: 80px !important;
  position: relative;
  top: 130px;
  left: 150px;
  z-index: 10;
}
.qr-code{
  position: relative;
  bottom: -312px;
  text-align: center;
  img{
    width: 175px;
  }
}
.bottom-text{
  font-size: 12px;
  position: relative;
  bottom: -302px;
  text-align: center;
}
.text1{
  width: 100vw;
  text-align: center;
  position: absolute;
  top:325px;
  font-size: 12px;
}
.text2{
  width: 100vw;
  text-align: center;
  position: absolute;
  top:1100px;
  font-size: 12px;
}
</style>
